import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Paper).attrs({
  elevation: 3,
})`
  width: 99%;
  max-width: 1620px;
  min-height: 100%;

  padding-left: 5px;
  padding-right: 5px;
`;
